<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showBankAccountModal"
                   :data="model"
                   size="lg"
                   :title="$t('Bank Account')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable
                   :disable-submit-btn="!hasBankAccountField">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <input-widget :autofocus="true" :model="model" attribute="account_name"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="sort_code"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="account_number"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="iban"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="swift"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="bank_name"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="address"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="address_2"/>
        </div>
        <div class="col-md-6 col-lg-4">
          <input-widget :model="model" attribute="address_3"/>
        </div>
        <div class="col-md-12">
          <hr>
        </div>
        <div class="col-md-12">
          <h5>{{ $t('Accounts Contact') }}</h5>
        </div>
        <div class="col-md-4">
          <input-widget :model="model" attribute="first_name"/>
        </div>
        <div class="col-md-4">
          <input-widget :model="model" attribute="last_name"/>
        </div>
        <div class="col-md-4">
          <input-widget :model="model" attribute="email"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import BankAccountForm from "../../../models/BankAccountForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "BankAccountModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new BankAccountForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleBankAccountModal', 'saveTermsBankAccount']),
      async onSubmit() {
        this.loading = true;

        this.model.customer_uuid = this.customer.uuid;
        let response = await this.saveTermsBankAccount(this.model);
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleBankAccountModal(false);
          this.$toast('success', this.$t('Bank account was successfully saved'));
        } else if (response.body.non_field_errors) {
          this.$errorDialog(response.body.non_field_errors[0]);
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new BankAccountForm(this.bankAccount);
      },
      onHidden() {
        this.model = new BankAccountForm();
        this.toggleBankAccountModal(false);
      },
    },
    watch: {
      bankAccount() {
        this.model = new BankAccountForm(this.bankAccount);
      }
    },
    computed: {
      ...mapState({
        showBankAccountModal: state => state.termsData.showBankAccountModal,
        bankAccount: state => state.termsData.bank_account,
        customer: state => state.customer
      }),
      hasBankAccountField() {
        return !!(this.model.account_name || this.model.account_number || this.model.swift || this.model.sort_code || this.model.iban || this.model.bank_name || this.model.address || this.model.address_2 || this.model.address_3);
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>

